import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class KWPunchoutOciForm extends TKCustomElementFactory {
    fetchURL?: string;
    submitURL?: string;
    form?: HTMLFormElement;

    constructor() {
        super();

        this.fetchURL = this.getAttribute('data-tk-fetch-url') || undefined;
        this.submitURL = this.getAttribute('data-tk-submit-url') || undefined;
    }

    connectedCallback(): void {
        if (!this.fetchURL || !this.submitURL) return;

        this.createFormStructure();
        this.registerListener();
    }

    /**
     * Create a hidden form element that will receive fetched data
     */
    private createFormStructure(): void {
        this.form = document.createElement('form');
        this.form.id = 'ocihtml';
        this.form.method = 'post';
        this.form.action = this.submitURL!;
        this.form.target = '_top';
        this.form.style.display = 'none';

        this.appendChild(this.form);
    }

    /**
     * Register click listener on button
     */
    private registerListener(): void {
        const button = this.querySelector('button');

        if (!button) return;

        this.pushListener({
            event: 'click',
            element: button,
            action: this.handleButtonClick.bind(this),
        });
    }

    /**
     * Handle button click: fetch data and submit form
     */
    private async handleButtonClick(): Promise<void> {
        if (!this.fetchURL || !this.form) return;

        const headers = new Headers({
            'x-requested-with': 'XMLHttpRequest',
            'response-type': 'json',
        });

        const init: RequestInit = {
            method: 'GET',
            headers,
            credentials: 'include',
        };

        const response = await fetch(this.fetchURL, init);
        const body = await response.text();

        this.handleFetchResponse(body);
    }

    /**
     * Handle fetch response: inject data into form and submit
     */
    private handleFetchResponse(response: string): void {
        if (!this.form) return;

        // Insert fetched content into the hidden form
        this.form.insertAdjacentHTML('afterbegin', response);

        // Submit the form
        this.form.submit();
    }
}
